module.exports = __webpack_public_path__ + "160fad866a5b9de26d81ae0102c05efa.png";